import { z } from "zod";

export const phaseFormFieldOptionSchema = z.object({
  key: z.string(),
  value: z.string(),
});

export const fieldConditionSchema = z.object({
  sourceFieldId: z.string(),
  operator: z.string(),
  value: z.any(),
});

export const fieldConditionGroupSchema = z.object({
  conditions: z.array(fieldConditionSchema),
  operator: z.string(),
});

// Base schema for PhaseFormFieldData
export const phaseFormFieldDataSchema = z
  .object({
    _id: z.string().optional(),
    fieldId: z.string().optional(),
    name: z.string().optional(),
    multiline: z.boolean().optional(),
    acceptFiles: z.boolean().optional(),
    type: z.string().optional(),
    text: z.string().optional(),
    description: z.string().optional(),
    videoUrl: z.string().optional(),
    processRole: z.string().optional(),
    assetType: z.string().optional(),
    tag: z.string().optional(),
    options: z.array(phaseFormFieldOptionSchema).optional(),
    required: z.boolean().optional(),
    conditionGroups: z.array(fieldConditionGroupSchema).optional(),
    mask: z.string().optional(),
    isPassword: z.boolean().optional(),
  })
  .catchall(z.any());

export const extendedPhaseFormSchema = z
  .object({
    _id: z.string().optional(),
    index: z.number().optional(),
    name: z.string().optional(),
    description: z.string().optional(),
    title: z.string().optional(),
    subtitle: z.string().optional(),
    short_description: z.string().optional(),
    phaseFormName: z.string().optional(),
    phaseFormId: z.string().optional(),
    type: z.enum(["OPENED", "CLOSED"]).optional(),
    format: z.enum(["SHORT", "LONG"]).optional(),
    emailTemplate: z.string().optional(),
    whatsappTemplate: z.string().optional(),
    hasAppointment: z.boolean().optional(),
    appointmentId: z.string().optional(),
    activity: z
      .object({
        name: z.string().optional(),
        documents: z.union([z.array(z.string()), z.record(z.any())]).optional(),
      })
      .optional(),
    phase: z
      .object({
        name: z.string().optional(),
      })
      .optional(),
    formFields: z.array(phaseFormFieldDataSchema).optional(),
    data: z
      .array(
        z.object({
          field: phaseFormFieldDataSchema,
          data: z.any(),
        }),
      )
      .optional(),
    createdAt: z.union([z.string(), z.date()]).optional(),
    updatedAt: z.union([z.string(), z.date()]).optional(),
  })
  .catchall(z.any());

export type ExtendedPhaseForm = z.infer<typeof extendedPhaseFormSchema>;
